window.__tnt || (window.__tnt = {});

(function(window, document, $, __tnt, undefined) {

    var me = __tnt.advertisements || (__tnt.advertisements = {});
    
})(window, document, jQuery, __tnt);